<style lang="less" scoped>
#csv {
  display: none;
}
/deep/.el-form-item__content {
  width: 240px !important;
}
.hide {
  visibility: hidden;
}
.page-main .page-content .content .searchs .subbtn {
  margin: 0;
  position: relative;
  top: 1px;
}
.table-list {
  padding: 20px 0;
  height: 34px;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="content-list">
          <div class="page-content">
            <div class="title">
              <el-row>
                <el-col :span="12">待处理报警消息</el-col>
                <el-col :span="12" class="text-right">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    :loading="signBtn.isBtnLoading"
                    :disabled="signBtn.isDisabled"
                    @click="alarmSign"
                    >{{ signBtn.btnText }}</el-button
                  >
                </el-col>
              </el-row>
            </div>
            <div class="content">
              <div class="table">
                <el-table
                  :data="tableData"
                  stripe
                  size="mini"
                  border
                  v-loading="pageLoading"
                  :show-header="false"
                >
                  <el-table-column label="自动站名称" align="center">
                    <template slot-scope="scope">
                      <router-link
                        class="font-color-theme cursor-pointer"
                        :to="
                          '/automaticStation/classify/' +
                            scope.row.device_detail.station_id
                        "
                        >{{ scope.row.station_name }}</router-link
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="设备名称" align="center">
                    <template slot-scope="scope">
                      <router-link
                        class="font-color-theme cursor-pointer"
                        :to="
                          pbFunc.stationTypePath(
                            scope.row.device_detail.device_type_code,
                            scope.row.device_detail.station_id,
                            scope.row.device_detail.device_id
                          )
                        "
                        >（{{ scope.row.device_sn }}）{{ scope.row.device_name }}</router-link
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="(item, key) in thTableList"
                    :key="key"
                    :prop="item.param"
                    align="center"
                    :label="item.title"
                  >
                    <template slot-scope="scope">
                      <div v-if="item.param === 'alarmType'">
                        <div :class="scope.row.alarmType.className">
                          {{ scope.row.alarmType.name }}
                        </div>
                      </div>
                      <div v-else>{{ scope.row[item.param] }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="报警时间" align="center">
                    <template slot-scope="scope">
                      <div>
                        {{ pbFunc.dateDiff(new Date(scope.row.alarm_time)) }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              class="table-list text-center"
              v-show="pageData.totalCount > 20"
            >
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="pageData.totalCount"
                :page-size="pageData.pageSize"
                :current-page.sync="pageData.currentPage"
                @current-change="pageChange"
                v-if="!pageLoading && pageData.totalCount > 20"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alarmPending", //警报待处理
  
  data() {
    return {
      pageLoading: false, //页面loading
      tableData: [],
      submitBtn: {
        btnText: "查询历史",
        isLoading: false,
        isDisabled: false
      },
      signBtn: {
        btnText: "全部标记为已读",
        isLoading: false,
        isDisabled: false
      },
      pageData: {
        currentPage: 1,
        totalCount: "",
        pageSize: 20
      },
      thTableList: [
        {
          title: "报警类别",
          param: "alarmType",
          className: "",
          width: ""
        },
        {
          title: "报警项目",
          param: "alarm_field",
          width: ""
        },
        {
          title: "测量数据",
          param: "alarm_data",
          width: ""
        },
      ],
      station: [] //自动站
    };
  },
  computed: {},
  methods: {
    search() {
      this.pageLoading = true;

      this.$$http("alarmList", {
        alarm_type: "", //报警类型
        read_status: 1, //消息状态
        station: "",
        device: "",
        alarm_time__range: "",
        page: this.pageData.currentPage,
        size: this.pageData.pageSize
      })
        .then(results => {
          this.pageLoading = false;
          //   this.nuclideData = [];
          if (results.data && results.status == 200) {
            this.pageData.totalCount = results.data.count;
            // this.$alarmNum = results.data.count;
            this.$store.commit('updateAlarm',results.data.count)
            this.tableData = results.data.results;
            for (let i in this.tableData) {
              this.tableData[i].alarmType = this.pbFunc.alarmTypeName(
                this.tableData[i].alarm_type
              );
            }
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "查询失败"
            );
          }
        })
        .catch(err => {
          this.pageLoading = false;
        });
    },
    pageChange() {
      setTimeout(() => {
        this.search();
      });
    },
    //标记已读
    alarmSign() {
      this.signBtn.isBtnLoading = true;
      this.$alarmNum = 0;
      
      this.$$http("alarmSign", {})
        .then(results => {
          this.signBtn.isBtnLoading = false;
          if (results.data && results.status == 200) {
            this.$store.commit('updateAlarm',0)
            this.search();
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "操作失败"
            );
          }
        })
        .catch(err => {
          this.signBtn.isBtnLoading = false;
        });
    }
  },
  created() {
    this.search();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/giveAnAlarm/alarmPending.vue